<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách công việc</h1>
      <!-- <div class="float-right btn-group" v-show="showImportBtn"> -->
      <div class="float-right btn-group">
        <template v-if="dataPermission && dataPermission?.includes('CNPS_CSS_IMPORT_FILE')">
          <b-button
            variant="outline-secondary"
            :disabled="isDownloadFile"
            v-b-tooltip.hover
            title="Tải file mẫu tạo công việc"
            @click="downloadTemplateFile"
          >
            <i
              class="bx"
              :class="{
                'bx-loader': isDownloadFile,
                'bx-download': !isDownloadFile,
              }"
            ></i>
            Template tạo CV
          </b-button>
          <b-button
            variant="outline-secondary"
            :disabled="isUploadFile"
            v-b-tooltip.hover
            title="Import file tạo công việc"
            @click="$refs.fileInput.click()"
          >
            <i class="bx" :class="{ 'bx-loader': isUploadFile, 'bx-upload': !isUploadFile }"></i>
            Tạo CV
          </b-button>
          <input
            type="file"
            ref="fileInput"
            accept=".xlsx"
            class="d-none"
            @change="handleFileChange"
          />
        </template>

        <template
          v-if="dataPermission && dataPermission?.includes('CNPS_CSS_TASK_IMPORT_UPDATE_HANDLER')"
        >
          <b-button
            variant="outline-secondary"
            :disabled="isDownloadFileSale"
            v-b-tooltip.hover
            title="Tải file mẫu gán Sales"
            @click="downloadTemplateFileSale"
          >
            <i
              class="bx"
              :class="{
                'bx-loader': isDownloadFileSale,
                'bx-download': !isDownloadFileSale,
              }"
            ></i>
            Template gán Sales
          </b-button>
          <b-button
            variant="outline-secondary"
            :disabled="isUploadFileSale"
            v-b-tooltip.hover
            title="Import file gán Sales"
            @click="$refs.fileInputSale.click()"
          >
            <i
              class="bx"
              :class="{ 'bx-loader': isUploadFileSale, 'bx-upload': !isUploadFileSale }"
            ></i>
            Gán Sales
          </b-button>
          <input
            type="file"
            ref="fileInputSale"
            accept=".xlsx"
            class="d-none"
            @change="handleFileChangeSale"
          />
        </template>

        <template
          v-if="dataPermission && dataPermission?.includes('CNPS_CSS_TASK_IMPORT_UPDATE_PRIORITY')"
        >
          <b-button
            variant="outline-secondary"
            :disabled="isDownloadFilePriority"
            v-b-tooltip.hover
            title="Tải file mẫu update ưu tiên"
            @click="downloadTemplateFilePriority"
          >
            <i
              class="bx"
              :class="{
                'bx-loader': isDownloadFilePriority,
                'bx-download': !isDownloadFilePriority,
              }"
            ></i>
            Template ưu tiên
          </b-button>

          <b-button
            variant="outline-secondary"
            :disabled="isUploadFileSale"
            v-b-tooltip.hover
            title="Import file update ưu tiên"
            @click="$refs.fileInputPriority.click()"
          >
            <i
              class="bx"
              :class="{ 'bx-loader': isUploadFilePriority, 'bx-upload': !isUploadFilePriority }"
            ></i>
            Ưu tiên
          </b-button>
          <input
            type="file"
            ref="fileInputPriority"
            accept=".xlsx"
            class="d-none"
            @change="handleFileChangePriority"
          />
        </template>

        <template v-if="dataPermission && dataPermission?.includes('CNPS_CSS_TASK_EXPORT')">
          <b-button
            variant="outline-secondary"
            :disabled="isLoadingDownTemplate"
            v-b-tooltip.hover
            title="Export danh sách công việc"
            @click="exportExcel"
          >
            <i class="bx bx-download"></i>{{ isLoadingDownTemplate ? 'Đang tải...' : 'List CV' }}
          </b-button>
        </template>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keyword"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              @keydown.enter.prevent="fetchData"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.moId"
              :options="moOptions"
              :settings="moSettings"
              placeholder="Tìm kiểm merchant owner"
              @change="onChangeMo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.maId"
              :options="maOptions"
              :settings="maSettings"
              placeholder="Tìm kiếm merchant account"
              @change="onChangeMa"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.storeId"
              :options="storeOptions"
              :settings="storeSettings"
              placeholder="Tìm kiếm cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessRegionCode"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessProvinceCode"
              :options="dataProvince"
              :disabled="!search.businessRegionCode || search.businessRegionCode === '0'"
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố merchant"
              :disabled="!search.regionCode || search.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện merchant"
              :disabled="!search.provinceCode || search.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCodeStore"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event, 1)"
              placeholder="Vùng cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceCodeStore"
              :options="dataProvinceMCStore"
              placeholder="Tỉnh/Thành phố cửa hàng"
              :disabled="!search.regionCodeStore || search.regionCodeStore === '0'"
              @change="getMcDistrictStore($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.districtCodeStore"
              :options="dataDistrictStore"
              placeholder="Quận/Huyện cửa hàng"
              :disabled="!search.provinceCodeStore || search.provinceCodeStore === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.handlerMainRegionId"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event, 2)"
              placeholder="Vùng của người xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.handlerMainProvinceId"
              :options="dataProvinceMC2"
              placeholder="Tỉnh của người xử lý"
              :disabled="!search.handlerMainRegionId || search.handlerMainRegionId === '0'"
            />
            <!-- @change="getMcDistrict($event)" -->
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRangeProcessing"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian xử lý
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRangeEndIntendTime"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian XL dự kiến
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="dataStaff" placeholder="Người xử lý">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.group"
              :options="Config.getSearch(optionsType)"
              @change="getCatCalendar"
              placeholder="Nhóm công việc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.name"
              :options="Config.getSearch(optionsPurpose)"
              placeholder="Tên công việc"
              :disabled="!search.group || search.group === '0'"
              @change="onTaskNameChange"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.subCategoryCode"
              :options="subCategoryOptions"
              placeholder="Tiểu mục CV"
              :disabled="!search.name || search.name === '0'"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.callioResult"
              :options="callioResultOptions"
              placeholder="Kết quả cuộc gọi"
              :disabled="
                !search.group || search.group === '0' || !search.name || search.name === '0'
              "
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(optionStatus)"
              placeholder="Trạng thái chăm sóc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.approvedStatus"
              :options="optionStatusApprove"
              placeholder="Trạng thái duyệt"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.result" :options="optionResult" placeholder="Kết quả">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.applyFor" :options="dataApplyFor" placeholder="Đối tượng">
            </Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.methodCare"
              :options="listMethodCare"
              placeholder="Loại chăm sóc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typePosm"
              :options="[
                { id: 0, text: 'Tất cả' },
                { id: 'POSM_1', text: 'POSM mẫu 1' },
                { id: 'POSM_2', text: 'POSM mẫu 2' },
                { id: 'POSM_1_2', text: 'POSM mẫu 1 và 2' },
              ]"
              placeholder="Loại POSM"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.reasonFailure"
              :options="taskFailedReasonsOptions"
              placeholder="Lý do"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeSale"
              :options="optionHandler"
              placeholder="Vai trò người xử lý"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusChangeInfo"
              :options="Config.getSearch(Config.statusChangeInfo)"
              placeholder="TT thay đổi thông tin trên MNP"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusApproveMpos"
              :options="Config.getSearch(Config.statusApproveMpos)"
              placeholder="Trạng thái duyệt trên Mpos"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.transformStatus"
              :options="transformStatusFilterOptions"
              placeholder="Trạng thái chuyển đổi"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.priorities"
              :options="priorityOptions"
              :settings="{
                multiple: true,
                allowClear: true,
                placeholder: 'Ưu tiên',
              }"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusSupportMc"
              :options="statusSupportMcOptions"
              :settings="{
                placeholder: 'Trạng thái hỗ trợ MC',
              }"
            />
          </div>
          <div class="form-group">
            <button
              @click="
                onClearSelect()
                fetchData()
              "
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
          <div class="form-group" style="min-width: 500px">
            <button type="button" class="pt-2 btn btn-info hc-37" @click="addTask">Thêm</button>
            <button
              v-if="
                dataPermission && dataPermission?.includes('CNPS_CSS_ASSIGN_TASK_AND_ASSIGN_STAFF')
              "
              type="button"
              class="pt-2 mx-2 btn btn-warning"
              @click="handleAssignTask"
              :disabled="!hasNewStatusCheckeds"
              v-b-tooltip.hover="
                !hasNewStatusCheckeds
                  ? 'Vui lòng chọn ít nhất 1 công việc ở trạng thái Mới tạo'
                  : ''
              "
            >
              <!-- <i class="bx bx-user-plus"></i><span>&nbsp;</span>Giao việc -->
              Giao việc
              <span v-if="hasNewStatusCheckeds" class="badge badge-light ml-1">{{
                newStatusSelectedCount
              }}</span>
            </button>
            <button
              v-if="
                dataPermission && dataPermission?.includes('CNPS_CSS_TASK_UPDATE_TRANSFORM_STATUS')
              "
              type="button"
              class="pt-2 mr-2 btn btn-primary"
              :disabled="!hasConvertNlCheckeds"
              v-b-tooltip.hover="
                !hasConvertNlCheckeds ? 'Vui lòng chọn ít nhất 1 công việc Ký HĐ Ngân Lượng' : ''
              "
              @click="handleUpdateTransformStatus"
            >
              <!-- <i class="bx bx-refresh"></i><span>&nbsp;</span> -->
              Cập nhật TT chuyển đổi
              <span v-if="hasConvertNlCheckeds" class="badge badge-light ml-1">{{
                convertNlSelectedCount
              }}</span>
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <!-- Tổng công việc:<strong class="text-primary">&nbsp;{{ pagination.total | formatNumberVN }}</strong> -->
            <TotalCount :totals="pagination.total" :data="totals" />
            <b-table
              :busy.sync="loading"
              head-variant="light"
              sticky-header
              hover
              responsive
              :items="dataTask"
              show-empty
              empty-text="Không có dữ liệu!"
              :fields="fieldsTable"
              selectable
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <!-- Checkbox header - chỉ active khi có item có thể chọn -->
              <template #head(checkbox)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="loading || selectableItems.length === 0"
                />
              </template>

              <!-- Checkbox từng hàng - disabled nếu không phải trạng thái NEW -->
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox
                  v-model="item.checked"
                  @change="toggleSelectOne(item)"
                  :disabled="!canSelectItem(item)"
                  v-b-tooltip.hover="
                    !canSelectItem(item)
                      ? 'Chỉ có trạng thái Mới tạo hoặc công việc Ký HĐ Ngân Lượng mới được phép chọn'
                      : ''
                  "
                />
              </template>
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(task)="data">
                <p>{{ data.item.name ?? '' }}</p>
                <p>
                  <b class="text-muted">Tiểu mục CV:</b>
                  {{ data.item.subCategoryName ?? '' }}
                </p>
                <p class="text-primary">
                  {{ data.item.group ? joinArrayData(data.item.group, optionsType) : '' }}
                </p>
                <p>
                  <b class="text-muted">Hình thức:</b>
                  {{ data.item.methodCare }}
                </p>
              </template>
              <template #cell(time)="data">
                <div class="d-flex text-nowrap">
                  <div>
                    <b class="text-muted d-inline-block" style="width: 32px">Tạo: </b
                    ><span class="text-nowrap" v-if="data.item.createdDate">{{
                      data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY')
                    }}</span
                    ><br />
                  </div>
                  <div class="ml-1 text-nowrap" style="color: #999">
                    ({{ showDateAgo(data.item.createdDate) }})
                  </div>
                </div>
                <div class="">
                  <div>
                    <b class="" style="width: 32px; color: #6c757d">Hoàn thành: </b
                    ><span class="text-nowrap" v-if="data.item.lastModifiedDate">{{
                      data.item.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY')
                    }}</span
                    ><br />
                  </div>
                  <div class="ml-1 text-nowrap" style="color: #999">
                    ({{ showDateAgo(data.item.lastModifiedDate) }})
                  </div>
                </div>
              </template>
              <template #cell(handler)="data">
                <div>
                  <b class="text-muted d-inline-block" style="width: 68px">Người tạo: </b>
                  <span v-if="data.item.createdInfo">{{
                    data.item.createdInfo.name ?? data.item.createdInfo.name
                  }}</span>
                  <br />
                </div>
                <div>
                  <b class="text-muted d-inline-block" style="width: 68px">Người xử lý: </b>
                  <span v-if="data.item.assignee">{{ data.item.assignee.name ?? '' }}</span>
                </div>
                <div v-show="data.item?.assignee?.name">
                  <b class="text-muted d-inline-block mr-1">Vai trò người xử lý: </b>
                  <span v-show="data.item.handler.typeSaleStr">{{
                    data.item?.handler?.typeSaleStr ?? ''
                  }}</span>
                </div>
                <div
                  v-if="
                    data.item?.acceptTransformUrl &&
                    Array.isArray(data.item?.purposes) &&
                    data.item.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
                  "
                >
                  <b class="text-muted d-inline-block">Ưu tiên: </b>
                  <span class="ml-1">{{ data.item?.priority ?? '' }}</span>
                </div>
              </template>
              <template #cell(status)="{ item }">
                <div style="width: 220px">
                  <div>
                    <span class="text-muted" style="font-size: 11px">Chăm sóc: </span>

                    <span class="badge" :class="getStatusClass(item?.status)">{{
                      getStatusName(item?.status)
                    }}</span>
                  </div>
                  <div v-if="item?.transformStatus" class="mt-2">
                    <span class="text-muted" style="font-size: 11px">Chuyển đổi: </span>
                    <span class="badge" :class="getTransformStatusClass(item?.transformStatus)">{{
                      getTransformStatusName(item?.transformStatus)
                    }}</span>
                  </div>
                </div>
              </template>
              <template #cell(statusChangeInfo)="{ item }">
                <div v-if="item?.statusChangeInfo">
                  <span class="badge" :class="getStatusChangeInfoClass(item?.statusChangeInfo)">{{
                    getStatusChangeInfoName(item?.statusChangeInfo)
                  }}</span>
                </div>
              </template>
              <template #cell(approvedStatus)="{ item }">
                <div v-if="item?.statusApproveMpos">
                  <p class="mb-0">
                    <b class="text-muted">MPos duyệt:</b>
                    <span
                      class="badge ml-1"
                      :class="getStatusApproveMposClass(item?.statusApproveMpos)"
                      >{{ getStatusApproveMposName(item?.statusApproveMpos) }}</span
                    >
                  </p>
                </div>
                <div v-else-if="item?.approvedStatus">
                  <p class="mb-0">
                    <b class="text-muted">MKT duyệt:</b>
                    <span class="badge ml-1" :class="getApproveClass(item?.approvedStatus)">{{
                      getApproveName(item?.approvedStatus)
                    }}</span>
                  </p>
                  <p v-if="item?.approvedStatus == 'REJECTED'" class="mb-0 mt-1">
                    <b class="text-muted">Lý do:</b>
                    <span>{{ item?.reasonReject || '' }}</span>
                  </p>
                </div>
              </template>
              <template #cell(merchant)="data">
                <div
                  v-if="
                    data.item.applyFor == 'STORE' &&
                    data.item.storeInfo &&
                    Object.keys(data.item.storeInfo).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">Cửa hàng:</span>
                    {{ data.item.storeInfo.name ?? '' }}
                  </p>
                  <div v-if="data.item.storeInfo.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <template v-if="isPhoneLike(data.item.storeInfo.email)">
                      <span class="ml-1">{{ maskedPhoneDisplay(data.item.storeInfo.email) }}</span>
                      <b-icon
                        icon="clipboard"
                        class="ml-1"
                        style="cursor: pointer"
                        v-b-tooltip.hover="'Sao chép'"
                        @click="copyToClipboard(normalizePhone(data.item.storeInfo.email))"
                      ></b-icon>
                    </template>
                    <template v-else>
                      <a :href="`mailto:${data.item.storeInfo.email}`">
                        {{ data.item.storeInfo.email }}</a
                      >
                    </template>
                  </div>
                  <div v-if="data.item.storeInfo.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.storeInfo.address)"
                      >{{ data.item.storeInfo.address }}</strong
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    data.item.applyFor == 'MO' &&
                    data.item.customerInfoRes &&
                    Object.keys(data.item.customerInfoRes).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">MO: </span>
                    {{ data.item.customerInfoRes.merchantName ?? '' }}
                  </p>
                  <div v-if="data.item.customerInfoRes.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <template v-if="isPhoneLike(data.item.customerInfoRes.email)">
                      <span class="ml-1">{{
                        maskedPhoneDisplay(data.item.customerInfoRes.email)
                      }}</span>
                      <b-icon
                        icon="clipboard"
                        class="ml-1"
                        style="cursor: pointer"
                        v-b-tooltip.hover="'Sao chép'"
                        @click="copyToClipboard(normalizePhone(data.item.customerInfoRes.email))"
                      ></b-icon>
                    </template>
                    <template v-else>
                      <a :href="`mailto:${data.item.customerInfoRes.email}`">{{
                        data.item.customerInfoRes.email
                      }}</a>
                    </template>
                  </div>
                  <div v-if="data.item.customerInfoRes.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.customerInfoRes.address)"
                      >{{ data.item.customerInfoRes.address }}</strong
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    data.item.applyFor == 'MA' &&
                    data.item.customerInfoRes &&
                    Object.keys(data.item.customerInfoRes).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">MA: </span>
                    {{ data.item.customerInfoRes.merchantName ?? '' }}
                  </p>
                  <div v-if="data.item.customerInfoRes.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <template v-if="isPhoneLike(data.item.customerInfoRes.email)">
                      <span class="ml-1">{{
                        maskedPhoneDisplay(data.item.customerInfoRes.email)
                      }}</span>
                      <b-icon
                        icon="clipboard"
                        class="ml-1"
                        style="cursor: pointer"
                        v-b-tooltip.hover="'Sao chép'"
                        @click="copyToClipboard(normalizePhone(data.item.customerInfoRes.email))"
                      ></b-icon>
                    </template>
                    <template v-else>
                      <a :href="`mailto:${data.item.customerInfoRes.email}`">{{
                        data.item.customerInfoRes.email
                      }}</a>
                    </template>
                  </div>
                  <div v-if="data.item.customerInfoRes.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.customerInfoRes.address)"
                      >{{ data.item.customerInfoRes.address }}</strong
                    >
                  </div>
                </div>

                <div
                  v-if="
                    data.item.applyFor == 'STORE' &&
                    data.item.customerInfoRes &&
                    Object.keys(data.item.customerInfoRes).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">MA: </span>
                    {{ data.item.customerInfoRes.merchantName ?? '' }}
                  </p>
                  <div v-if="data.item.customerInfoRes.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <template v-if="isPhoneLike(data.item.customerInfoRes.email)">
                      <span class="ml-1">{{
                        maskedPhoneDisplay(data.item.customerInfoRes.email)
                      }}</span>
                      <b-button
                        size="sm"
                        variant="link"
                        class="p-0 ml-1"
                        @click="copyToClipboard(normalizePhone(data.item.customerInfoRes.email))"
                        >Coppy</b-button
                      >
                    </template>
                    <template v-else>
                      <a :href="`mailto:${data.item.customerInfoRes.email}`">{{
                        data.item.customerInfoRes.email
                      }}</a>
                    </template>
                  </div>
                  <div v-if="data.item.customerInfoRes.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.customerInfoRes.address)"
                      >{{ data.item.customerInfoRes.address }}</strong
                    >
                  </div>
                </div>
                <p>
                  <span class="text-muted">MC MPOS ID: </span>
                  {{ data.item.merchantMposId ?? '' }}
                </p>
                <p>
                  <span class="text-muted">Mobile: </span>
                  <span
                    style="font-weight: 500; cursor: pointer"
                    @click="data.item.isShowMobile = !data.item.isShowMobile"
                    >{{
                      data.item.isShowMobile
                        ? data.item.merchantInfo?.mobile
                        : maskPhone(data.item.merchantInfo?.mobile)
                    }}</span
                  >
                </p>
              </template>
              <template #cell(province)="{ item }">
                <div class="text-center" v-if="item?.locationData?.provinceCodeTask">
                  {{ getCityName(item?.locationData?.provinceCodeTask) }}
                </div>
              </template>
              <template #cell(result)="{ item }">
                <div v-if="item?.result" style="min-width: 200px">
                  <div class="d-flex align-items-center">
                    <p class="text-muted mr-1">Kết quả công việc:</p>
                    <span>
                      {{ mapTextOptionResult[item.result] ?? '' }}
                    </span>
                  </div>

                  <div v-show="item?.reasonFailure">
                    <b class="text-muted">Lý do thất bại: </b>
                    <span>
                      {{ item.reasonFailure ?? '' }}
                    </span>
                  </div>
                </div>
                <div v-if="item?.callioResultText" style="min-width: 200px">
                  <div class="d-flex align-items-center">
                    <p class="text-muted mr-1">Kết quả cuộc gọi:</p>
                    <span>
                      {{ item?.callioResultText ?? '' }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="
                    item?.acceptTransformUrl &&
                    Array.isArray(item?.purposes) &&
                    item?.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
                  "
                  class="d-flex align-items-center mt-2"
                  style="min-width: 200px"
                >
                  <!-- <span class="text-muted mr-1">Link: </span> -->
                  <a
                    href="#"
                    @click.prevent="copyToClipboard(item.acceptTransformUrl)"
                    class="text-truncate d-inline-block"
                    style="max-width: 150px; vertical-align: bottom"
                    :title="item.acceptTransformUrl"
                  >
                    {{ item.acceptTransformUrl }}
                  </a>
                  <b-icon
                    icon="clipboard"
                    class="ml-1"
                    style="cursor: pointer"
                    v-b-tooltip.hover="'Sao chép'"
                    @click="copyToClipboard(item.acceptTransformUrl)"
                  ></b-icon>
                </div>
              </template>
              <template #cell(service)="{ item }">
                <div
                  v-if="
                    item &&
                    Array.isArray(item?.purposes) &&
                    item?.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
                  "
                >
                  <div v-if="typeof item?.createLinkPayment === 'number'">
                    <span class="text-muted">LinkPayment: </span>
                    <span class="text-success" v-show="item?.createLinkPayment === 1">Bật</span>
                    <span class="text-danger" v-show="item?.createLinkPayment === 0">Tắt</span>
                  </div>
                  <div v-if="typeof item?.isPayLink === 'number'">
                    <span class="text-muted">PayLink trả góp: </span>
                    <span class="text-success" v-show="item?.isPayLink === 1">Bật</span>
                    <span class="text-danger" v-show="item?.isPayLink === 0">Tắt</span>
                  </div>
                </div>
              </template>
              <template #cell(statusSupportMc)="{ item }">
                <div v-if="item?.statusSupportMc">
                  <div>
                    <span class="text-muted">Thông tin liên hệ: </span>
                    <span>{{ item?.infoContactSupportMc }}</span>
                  </div>
                  <div>
                    <span class="text-muted">Ghi chú MC: </span>
                    <span>{{ item?.noteSupportMc }}</span>
                  </div>
                  <div>
                    <span class="text-muted">Ghi chú CVKD: </span>
                    <span
                      class="text-truncate d-inline-block"
                      v-b-tooltip.hover="item?.saleNoteSupportMc"
                    >
                      {{ item?.saleNoteSupportMc }}
                    </span>
                  </div>
                  <div>
                    <span class="text-muted">Trạng thái hỗ trợ: </span>
                    <span>{{ getNameStatusSupportMc(item?.statusSupportMc) }}</span>
                  </div>
                </div>
              </template>
              <template #cell(action)="{ item }">
                <div class="text-left m-b-5">
                  <b-link
                    :to="`/customer-support/task/${item.id}`"
                    target="_blank"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <img
                      src="@/assets/img/circle-three-dots.svg"
                      alt="Circle with Three Dots"
                      style="width: 15px; height: 15px"
                    />
                    Chi tiết
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="showEditBtn(item)">
                  <b-link
                    :to="`/customer-support/task/${item.id}/edit`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i>
                    Cập nhật
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="showSupportMcBtn(item)">
                  <b-link style="color: #0056f6" size="sm" @click="handleSupportMc(item)">
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i>
                    Hỗ trợ MC
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="showProcessBtn(item)">
                  <b-link
                    :to="`/customer-support/task/${item.id}/process`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i>
                    Xử lý
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="showCancelBtn(item)">
                  <b-link style="color: #0056f6" size="sm" @click="handleConfirmCancel(item)">
                    <i class="bx bx-minus" style="width: 15px; height: 15px"></i>
                    Huỷ
                  </b-link>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end pagination-bottom">
        <b-form-group class="mb-0" style="padding: 17px">
          <b-form-select
            v-model="search.limit"
            :options="pageOptions"
            @change="onItemsPerPageChange"
          ></b-form-select>
        </b-form-group>
        <b-pagination
          v-model="search.page"
          @change="onChangePage"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>

    <PopupUpdateTask ref="popupUpdateTaskRef" @updateCalendar="fetchData" />
    <PopupShowInfoImport ref="popupShowInfoImportRef" @close="onClosePopupImport" />
    <PopupConfirmCancel ref="popupConfirmCancelRef" @change="fetchData" />
    <PopupAssignTask ref="popupAssignTaskRef" @submit="onAssignTaskSubmit" />
    <PopupUpdateTransformStatus
      ref="popupUpdateTransformStatusRef"
      @success="
        onClearSelect()
        fetchData()
      "
    />
    <ModalExportNoti ref="uploadNotif" />
    <PopupInputSupportMc ref="popupInputSupportMcRef" @change="fetchData" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { vi } from 'vuejs-datepicker/dist/locale'
  import { StaffService } from '@/services/staff.service'
  import { LocationService } from '@/services/location.service'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin.js'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import {
    List,
    WorkGroupList,
    WorkTaskList,
    DownloadFileTemplate,
    UploadFileListTask,
    // gán sale
    DownloadFileTemplateSale,
    UploadFileListTaskSale,
    // update ưu tiên
    DownloadFileTemplatePriority,
    UploadFileListTaskPriority,
  } from '@/services/customer-support/task'
  import PopupUpdateTask from './components/PopupUpdateTask.vue'
  import { List as ListMo } from '@/services/customer-support/merchant-owner'
  import { Search as ListMa } from '@/services/customer-support/account'
  import { List as ListStore } from '@/services/customer-support/store'
  import {
    EnumTaskMethodCare,
    TaskMethodCare,
    TaskStatus,
    mapResultName,
    EnumTaskStatus,
    EnumTaskResultStatus,
    TRANSFORM_STATUS_OPTIONS,
  } from '@/constant/customerSupport'
  import { SearchByCode } from '@/services/customer-support/location'
  import PopupShowInfoImport from './components/PopupShowInfoImport.vue'
  import { showMess, showMessErrorResponse, showMessError } from '@/config/utils'
  import FileDownload from 'js-file-download'
  import { getDateAgo } from '@/utils/util'
  import TotalCount from '@/components/cskh/Counts.vue'
  import PopupConfirmCancel from './components/PopupConfirmCancel'
  import PopupAssignTask from './components/PopupFindStaff.vue'
  import PopupUpdateTransformStatus from './components/PopupUpdateTransformStatus.vue'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { CommonService } from '@/services/common.service.js'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import PopupInputSupportMc from './components/PopupInputSupportMc.vue'

  const fieldsTable = [
    { key: 'checkbox', label: '', sortable: false, thStyle: 'width: 30px; text-align: center' }, // Thêm dòng này
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchant', label: 'Merchant/Cửa hàng', thStyle: 'width: 140px' },
    { key: 'province', label: 'Tỉnh/Thành phố' },
    { key: 'task', label: 'Công việc', class: 'task_class', thStyle: 'min-width: 200px' },
    {
      key: 'time',
      label: 'Thời gian',
      class: 'time_class',
      thStyle: 'min-width: 250px',
    },
    { key: 'handler', label: 'NV tạo/xử lý', thStyle: 'min-width: 190px' },
    { key: 'status', label: 'Trạng thái', class: 'text-center' },
    {
      key: 'statusChangeInfo',
      label: 'TT thay đổi TT trên MNP',
      class: 'text-center',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'approvedStatus',
      label: 'Trạng thái duyệt',
      class: 'text-center',
      thStyle: 'min-width: 150px',
    },

    {
      key: 'result',
      label: 'Kết quả',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'service',
      label: 'Dịch vụ',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'statusSupportMc',
      label: 'Thông tin hỗ trợ MC',
      thStyle: 'min-width: 250px',
    },
    {
      key: 'action',
      label: 'Thao tác',
      fixIndex: 999,
      class: 'text-left',
      thStyle: 'min-width: 120px',
    },
  ]

  const CONVERT_NL_TASK_NAME = 'Ký HĐ Ngân Lượng'
  const CHUYEN_DOI_NGAN_LUONG_PURPOSE = 'CHUYEN_DOI_NGAN_LUONG'

  const currentUser = JSON.parse(localStorage.getItem('userData'))

  const STATUS_SUPPORT_MC_OPTIONS = [
    { id: 'PROCESSED', text: 'Đã xử lý' },
    { id: 'UNPROCESSED', text: 'Chưa xử lý' },
  ]

  const STATUS_SUPPORT_MC_MAP = {
    PROCESSED: 'Đã xử lý',
    UNPROCESSED: 'Chưa xử lý',
  }

  export default {
    name: 'calendarAFS',
    components: {
      PopupUpdateTask,
      PopupShowInfoImport,
      TotalCount,
      PopupConfirmCancel,
      PopupAssignTask,
      PopupUpdateTransformStatus,
      ModalExportNoti,
      PopupInputSupportMc,
    },
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      return {
        Config,
        EnumTaskMethodCare,
        EnumTaskStatus,
        EnumTaskResultStatus,
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        listMethodCare: [{ id: '0', text: 'Tất cả' }, ...TaskMethodCare],
        fieldsTable,
        selectAll: false,
        idsSelected: [],
        dataTable: [], // mỗi item có thuộc tính checked
        maxtSelect: 200, // giới hạn số lượng chọn
        // filterTable: fieldsTable,
        // userData: JSON.parse(localStorage.getItem('userData')),
        currentUser,
        search: {
          page: 1,
          limit: 20,
          keyword: '',
          saleId: '',
          group: '',
          name: '',
          status: '',
          moId: '',
          maId: '',
          storeId: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          applyFor: '',
          methodCare: '',
          approvedStatus: '',
          result: '',
          callioResult: '',
          handlerMainRegionId: '',
          handlerMainProvinceId: '',
          regionCodeStore: '',
          provinceCodeStore: '',
          districtCodeStore: '',
          statusChangeInfo: '',
          statusApproveMpos: '',
          transformStatus: '',
          priorities: [],
          statusSupportMc: '',
        },
        pagination: {
          total: 0,
          conditionsMap: '',
        },
        dataTask: [],
        statistical: {},
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeProcessing: {
          startDate: null,
          endDate: null,
        },
        dateRangeEndIntendTime: {
          startDate: null,
          endDate: null,
        },
        dataStaff: [],
        dataDistrictStore: [],

        dataConfigRegion: [],
        dataProvince: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],
        dataProvinceMC2: [],
        dataDistrict: [],
        dataApplyFor: [
          { id: 0, text: 'Tất cả' },
          { id: 'MA', text: 'Merchant Account' },
          { id: 'MO', text: 'Merchant Owner' },
          { id: 'STORE', text: 'Store' },
        ],
        cityList: [],

        optionsPurpose: [],
        update: {},
        // dateRangeProcessing: {
        //   startProcessingDate: null,
        //   endProcessingDate: null
        // },
        resonArr: [],
        purposesSelected: null,
        loading: true,
        showLoading: false,
        vi: vi,
        fileImage: [],
        dataUpdate: {},
        // optionStatus: [
        //   { id: 'NEW', text: 'Mới tạo' },
        //   { id: 'PROCESSING', text: 'Đang xử lý' },
        //   { id: 'FINISH', text: 'Hoàn thành' },
        //   { id: 'CANCELED', text: 'Đã hủy' },
        // ],
        optionStatusApprove: [
          { id: '0', text: 'Tất cả' },
          { id: 'APPROVED', text: 'Đã duyệt', bgColor: 'badge-info' },
          { id: 'WAIT_APPROVED', text: 'Chưa duyệt', bgColor: 'badge-success' },
          { id: 'REJECTED', text: 'Từ chối', bgColor: 'badge-danger' },
        ],
        optionResult: [
          { id: '0', text: 'Tất cả' },
          { id: 'SUCCESS', text: 'Thành công', bgColor: 'badge-success' },
          { id: 'FAILED', text: 'Thất bại', bgColor: 'badge-danger' },
          { id: 'OTHERS', text: 'Khác', bgColor: 'badge-info' },
        ],

        optionStatus: [{ id: '0', text: 'Tất cả' }, ...TaskStatus],
        optionColorStatus: {
          NEW: 'badge type-primary',
          PROCESSING: 'badge type-warning',
          FINISH: 'badge type-success',
          CANCELED: 'badge type-danger',
        },
        optionsType: [],
        optionHandler: [],

        moOptions: [],
        maOptions: [],
        storeOptions: [],
        taskFailedReasonsOptions: [],

        // Transform status
        transformStatusFilterOptions: [{ id: '0', text: 'Tất cả' }, ...TRANSFORM_STATUS_OPTIONS],
        transformStatusSelectOptions: TRANSFORM_STATUS_OPTIONS,
        showTransformStatusModal: false,
        selectedTransformStatus: '',
        CONVERT_NL_TASK_NAME,

        isDownloadFile: false,
        isUploadFile: false,

        // totals: {
        //   canceledRecord: 0,
        //   finishRecord: 0,
        //   newRecord: 0,
        //   notCompletedRecord: 0,
        //   processingRecord: 0,
        // },
        totals: [
          {
            status: 'Huỷ',
            status_class: 'text-danger',
            count: 0,
          },
          {
            status: 'Hoàn thành',
            status_class: 'text-success',
            count: 0,
          },
          {
            status: 'Mới tạo',
            status_class: 'text-primary',
            count: 0,
          },
          {
            status: 'Không hoàn thành',
            status_class: 'text-info',
            count: 0,
          },
          {
            status: 'Đang xử lý',
            status_class: 'text-warning',
            count: 0,
          },
        ],

        tLoadMo: undefined,
        moSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
              if (this.tLoadMo) {
                clearTimeout(this.tLoadMo)
              }
              this.tLoadMo = setTimeout(() => {
                ListMo({
                  // showFields: ["id", "ownerName", "email"],
                  limit: 10,
                  page: 1,
                  // queryString,
                  keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item.id,
                            text: item.ownerName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `{textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}'''`,
              ]
              this.search.maId && querys.push(`{mcAccountId} == '''${this.search.maId}'''`)

              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadStore: undefined,
        storeSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `({textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}''')`,
              ]
              this.search.moId && querys.push(`{merchantOwnerId} == '''${this.search.moId}'''`)
              this.search.maId && querys.push(`{mcAccountId} == '''${this.search.maId}'''`)

              if (this.tLoadStore) {
                clearTimeout(this.tLoadStore)
              }
              this.tLoadMa = setTimeout(() => {
                ListStore({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        dataProvinceMCStore: [],

        searchWork: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                CalendarAfsService.getWorkSubsection({
                  name: keySearch,
                  isActive: true,
                  page: 1,
                  limit: 20,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item.code || '',
                            text: item.name || '',
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        subCategoryOptions: [],
        isLoadingDownTemplate: false,
        CHUYEN_DOI_NGAN_LUONG_PURPOSE,

        // gán sale
        isDownloadFileSale: false,
        isUploadFileSale: false,

        // update ưu tiên
        isDownloadFilePriority: false,
        isUploadFilePriority: false,
        priorityOptions: [],

        // trạng thái hỗ trợ MC
        statusSupportMcOptions: [{ id: '0', text: 'Tất cả' }, ...STATUS_SUPPORT_MC_OPTIONS],
      }
    },
    created() {
      const queries = this.$router.currentRoute.query

      this.search.keyword = queries?.keyword ?? ''
      if (queries.moId && queries.moName) {
        this.moOptions = [
          {
            id: queries.moId,
            text: queries.moName,
          },
        ]
        this.search.moId = queries.moId
      }
      if (queries.maId && queries.maName) {
        this.maOptions = [
          {
            id: queries.maId,
            text: queries.maName,
          },
        ]
        this.search.maId = queries.maId
      }
      if (queries.storeId && queries.storeName) {
        this.storeOptions = [
          {
            id: queries.storeId,
            text: queries.storeName,
          },
        ]
        this.search.storeId = queries.storeId
      }
    },
    async mounted() {
      this.priorityOptions = Array.from({ length: 9 }, (_, i) => ({
        id: i + 1,
        text: String(i + 1),
      }))

      await this.loadStore()
      await this.getRegions()
      await this.getMcRegions()
      await this.getCityList()
      await this.getOptionType()
      await this.fetchStaffByIdSuperior()
      await this.fetchHandler()
      await this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        callioResultOptions: 'callio/callioResultOptions',
      }),
      canSelectItem() {
        return item => {
          return (
            item.status === 'NEW' ||
            (Array.isArray(item.purposes) && item.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE))
          )
        }
      },

      selectableItems() {
        return this.dataTask.filter(item => this.canSelectItem(item))
      },

      hasCheckeds() {
        return this.idsSelected.length > 0
      },

      // Chỉ đúng khi có ít nhất 1 item status NEW được chọn (dành cho nút Giao việc)
      hasNewStatusCheckeds() {
        return this.dataTask.some(
          item =>
            this.idsSelected.includes(item.id) &&
            (item.status === 'NEW' ||
              (item.status === 'PROCESSING' &&
                item.purposes?.[0] === CHUYEN_DOI_NGAN_LUONG_PURPOSE))
        )
      },

      // Đếm số item status NEW đang được chọn
      newStatusSelectedCount() {
        return this.dataTask.filter(
          item =>
            this.idsSelected.includes(item.id) &&
            (item.status === 'NEW' ||
              (item.status === 'PROCESSING' &&
                item.purposes?.[0] === CHUYEN_DOI_NGAN_LUONG_PURPOSE))
        ).length
      },

      // Chỉ đúng khi có ít nhất 1 item Ký HĐ Ngân Lượng được chọn (dành cho nút Cập nhật TT chuyển đổi)
      hasConvertNlCheckeds() {
        return this.dataTask.some(
          item =>
            this.idsSelected.includes(item.id) &&
            Array.isArray(item.purposes) &&
            item.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
        )
      },

      // Đếm số item Ký HĐ Ngân Lượng đang được chọn
      convertNlSelectedCount() {
        return this.dataTask.filter(
          item =>
            this.idsSelected.includes(item.id) &&
            Array.isArray(item.purposes) &&
            item.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
        ).length
      },
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      // optionStatusApprove
      getApproveName() {
        return status => {
          const map = this.optionStatusApprove?.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return map[status] || status
        }
      },
      getApproveClass() {
        return status => {
          const map = this.optionStatusApprove.reduce((acc, cur) => {
            acc[cur.id] = cur.bgColor
            return acc
          }, {})
          return map[status] || 'badge-info'
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
      getStatusName() {
        return status => {
          const objStatus = this.optionStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.optionStatus.find(s => s.id === status)
          return objStatus?.bgColor ? objStatus.bgColor : 'badge-primary'
        }
      },
      getStatusChangeInfoName() {
        return status => {
          const objStatus = Config.statusChangeInfo.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusChangeInfoClass() {
        return status => {
          const objStatus = Config.statusChangeInfo.find(s => s.id === status)
          return objStatus?.variant ? `badge-${objStatus.variant}` : 'badge-primary'
        }
      },
      getStatusApproveMposName() {
        return status => {
          const objStatus = Config.statusApproveMpos.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusApproveMposClass() {
        return status => {
          const objStatus = Config.statusApproveMpos.find(s => s.id === status)
          return objStatus?.variant ? `badge-${objStatus.variant}` : 'badge-primary'
        }
      },
      getResultName() {
        return result => {
          return mapResultName[result] || result
        }
      },
      getCityName() {
        return city => {
          const objCity = this.cityList.find(e => e.id === city)
          return objCity ? objCity.text : city
        }
      },

      getTransformStatusName() {
        return status => {
          const obj = TRANSFORM_STATUS_OPTIONS.find(item => item.id === status)
          return obj ? obj.text : status
        }
      },
      getTransformStatusClass() {
        return status => {
          const mapClass = {
            NEW: 'badge-secondary',
            NOTICE_MC: 'badge-info',
            MC_CONFIRMED: 'badge-primary',
            MC_ACTIVATED: 'badge-success',
            MC_SIGNED_NL_CONTRACT: 'badge-success',
            MC_REJECTED: 'badge-danger',
            MC_REJECTED_SIGNED_VM_LIQUIDATION: 'badge-danger',
            ADDITIONAL_TID: 'badge-warning',
            ADDITIONAL_MID: 'badge-warning',
          }
          return mapClass[status] || 'badge-secondary'
        }
      },
      showEditBtn() {
        return item => {
          if (
            Array.isArray(item?.purposes) &&
            item?.purposes?.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
          ) {
            return (
              [EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) && // trạng thái là NEW (Mới tạo)
              (item.createdBy === this.currentUser?.userId || // người tạo
                this.dataStaff.some(item => item.id === this.currentUser?.userId) ||
                item?.saleId === this.currentUser?.userId)
            )
          }
          return (
            // this.dataPermission.includes('CNPS_CSS_TASK_UPDATE') && // có quyền cập nhật
            ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) && // trạng thái là NEW || PROCESSING (Mới tạo, Đang xử lý)
              item?.saleId === this.currentUser?.userId) || // là người xử lý
            ([EnumTaskStatus.NEW].includes(item?.status) && // trạng thái là NEW (Mới tạo)
              (item.createdBy === this.currentUser?.userId || // người tạo
                this.dataStaff.some(item => item.id === this.currentUser?.userId))) // người quản lý của người xử lý
          )
        }
      },
      showProcessBtn() {
        return item => {
          return (
            [EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) &&
            item?.methodCare === EnumTaskMethodCare.ONLINE &&
            item?.saleId === this.currentUser?.userId
          )
        }
      },
      showCancelBtn() {
        return item => {
          return (
            ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) &&
              item?.saleId === this.currentUser?.userId) ||
            ([EnumTaskStatus.NEW].includes(item?.status) &&
              item?.createdBy === this.currentUser?.userId)
          )
        }
      },
      // showImportBtn() {
      //   return this.dataPermission.includes('CNPS_CSS_IMPORT_FILE')
      // },
      showDateAgo() {
        return date => {
          return getDateAgo(date)
        }
      },
      mapTextOptionResult() {
        return this.optionResult.reduce((acc, cur) => {
          acc[cur.id] = cur.text
          return acc
        }, {})
      },
      maskPhone() {
        return phone => {
          return this.$options.filters.maskPhone(phone)
        }
      },
      getNameStatusSupportMc() {
        return status => {
          return STATUS_SUPPORT_MC_MAP[status] || ''
        }
      },
      showSupportMcBtn() {
        return item => {
          return (
            item?.purposes?.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE) &&
            item?.statusSupportMc === 'UNPROCESSED'
          )
        }
      },
    },
    methods: {
      loadStore() {
        this.taskFailedReasonsOptions = [
          { id: '0', text: 'Tất cả' },
          ...this.$store.getters['common/allConfig'].taskFailedReasons,
        ]

        this.optionStatus = this.$store.getters['common/allConfig'].taskCskhStatus.map(e => {
          return {
            ...e,
            id: e.code,
            text: e.name,
          }
        })
      },
      async fetchStaffByIdSuperior() {
        try {
          const res = await StaffService.getStaffByIdSuperior({ userId: this.currentUser?.userId })
          if (res.code === 1000) {
            this.dataStaff =
              res.data.map(item => ({
                id: item.userId,
                text: `${item.name} - ${item.userName}`,
              })) || []
          }
        } catch (e) {
          showMessErrorResponse(this, e, 3000)
        }
      },
      onItemsPerPageChange() {
        this.search.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.fetchData()
      },
      async fetchHandler() {
        try {
          const res = await CommonService.getTypeSale({})
          if (res.success) {
            this.optionHandler = res.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.optionHandler.unshift({ id: '0', text: 'Tất cả' })
          } else {
            showMessError(this, res.message)
          }
        } catch (error) {
          showMessErrorResponse(this, error)
        }
      },
      handleAssignTask() {
        if (!this.hasNewStatusCheckeds) {
          showMess(
            this,
            'Thông báo',
            'Vui lòng chọn ít nhất 1 công việc ở trạng thái Mới tạo để giao',
            'warning',
            'b-toaster-top-right',
            3000
          )
          return
        }

        this.$refs.popupAssignTaskRef.show()
      },
      async onAssignTaskSubmit(data) {
        try {
          this.showLoading = true

          // Chỉ giao những công việc có trạng thái NEW
          const newStatusIds = this.dataTask
            .filter(
              item =>
                this.idsSelected.includes(item.id) &&
                (item.status === 'NEW' ||
                  (item.status === 'PROCESSING' &&
                    item.purposes?.[0] === CHUYEN_DOI_NGAN_LUONG_PURPOSE))
            )
            .map(item => item.id)

          const payload = {
            taskIds: newStatusIds,
            handlerId: data.staffSelected.id || '',
          }

          const res = await StaffService.assignTaskAll(payload)
          if (res.code === 1000) {
            // Reset selection và refresh data
            this.onClearSelect()
            await this.fetchData()
            showMess(
              this,
              'Thông báo',
              res.message || 'Giao việc thành công',
              'success',
              'b-toaster-top-right',
              3000
            )
          } else {
            showMess(
              this,
              'Thông báo',
              res.message || 'Có lỗi xảy ra khi giao việc',
              'danger',
              'b-toaster-top-right',
              5000
            )
          }

          // Sau khi giao việc thành công
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error.response?.message || error.message || 'Có lỗi xảy ra khi giao việc',
            'danger',
            'b-toaster-top-right',
            5000
          )
        } finally {
          this.showLoading = false
        }
      },

      onClearSelect() {
        // Xóa tất cả ID đã chọn
        this.idsSelected = []
        this.selectAll = false

        // Chỉ uncheck các item có thể chọn
        this.dataTask.forEach(item => {
          if (this.canSelectItem(item) && item.checked) {
            item.checked = false
          }
        })
      },
      toggleSelectAll() {
        const value = this.selectAll

        // Chỉ xử lý các item có thể chọn (trạng thái NEW)
        for (const item of this.selectableItems) {
          item.checked = value
          const id = item.id
          const index = this.idsSelected.indexOf(id)
          index >= 0 && this.idsSelected.splice(index, 1)
          if (value) {
            !this.idsSelected.includes(id) && this.idsSelected.push(id)
          }
        }
        this.cleanSelectIfOver()
      },

      toggleSelectOne(item) {
        // Chỉ cho phép toggle nếu item có thể chọn
        if (!this.canSelectItem(item)) return

        const id = item.id
        const index = this.idsSelected.indexOf(id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (item.checked) {
          !this.idsSelected.includes(id) && this.idsSelected.push(id)
        }

        // Cập nhật selectAll dựa trên các item có thể chọn
        this.selectAll = this.selectableItems.every(item => item.checked)
        this.cleanSelectIfOver()
      },

      handleUpdateTransformStatus() {
        if (!this.hasConvertNlCheckeds) return

        // Chỉ cập nhật những công việc Ký HĐ Ngân Lượng
        const convertNlIds = this.dataTask
          .filter(
            item =>
              this.idsSelected.includes(item.id) &&
              Array.isArray(item.purposes) &&
              item.purposes.includes(CHUYEN_DOI_NGAN_LUONG_PURPOSE)
          )
          .map(item => item.id)

        this.$refs.popupUpdateTransformStatusRef.show(convertNlIds)
      },

      // define ngày trên lịch
      transformDate() {
        this.search.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // Bỏ lọc
      async removeForm() {
        this.onClearSelect()
        this.search = {
          page: 1,
          limit: 200,
          keyword: '',
          saleId: '',
          group: '',
          name: '',
          status: '',
          moId: '',
          maId: '',
          storeId: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          applyFor: '',
          result: '',
          callioResult: '',
          typePosm: '',
          typeSale: '',
          statusChangeInfo: '',
          statusApproveMpos: '',
          transformStatus: '',
          priorities: [],
          statusSupportMc: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeProcessing = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeEndIntendTime = {
          startDate: null,
          endDate: null,
        }
        this.pagination = {
          total: 0,
        }

        await this.fetchData()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const textSearch = this.search.keyword?.trim()
        textSearch && (conditionsMap.keyword = textSearch)

        this.search.subCategoryCode &&
          this.search.subCategoryCode !== '0' &&
          conditions.push(`{subCategoryCode} == '''${this.search.subCategoryCode}'''`)

        this.search.approvedStatus &&
          this.search.approvedStatus !== '0' &&
          conditions.push(`{approvedStatus} == '''${this.search.approvedStatus}'''`)
        this.search.result &&
          this.search.result !== '0' &&
          conditions.push(`{result} == '''${this.search.result}'''`)

        this.search.callioResult &&
          this.search.callioResult !== '0' &&
          conditions.push(`{callioResult} == '''${this.search.callioResult}'''`)

        this.search.businessRegionCode &&
          this.search.businessRegionCode !== '0' &&
          (conditionsMap.businessRegionCode = this.search.businessRegionCode)
        this.search.businessProvinceCode &&
          this.search.businessProvinceCode !== '0' &&
          (conditionsMap.businessProvinceCode = this.search.businessProvinceCode)

        //
        this.search.handlerMainRegionId &&
          this.search.handlerMainRegionId !== '0' &&
          (conditionsMap.handlerMainRegionId = this.dataConfigRegionMC.find(
            item => item.id === this.search.handlerMainRegionId
          ).idForProvice)

        this.search.handlerMainProvinceId &&
          this.search.handlerMainProvinceId !== '0' &&
          (conditionsMap.handlerMainProvinceId = this.dataProvinceMC2.find(
            item => item.id === this.search.handlerMainProvinceId
          ).newId)
        //

        this.search.statusSupportMc &&
          this.search.statusSupportMc !== '0' &&
          (conditionsMap.statusSupportMc = this.search.statusSupportMc)

        this.search.regionCode &&
          this.search.regionCode !== '0' &&
          conditions.push(`{locationData.regionCodeTask} == '''${this.search.regionCode}'''`)
        this.search.provinceCode &&
          this.search.provinceCode !== '0' &&
          conditions.push(`{locationData.provinceCodeTask} == '''${this.search.provinceCode}'''`)
        this.search.districtCode &&
          this.search.districtCode !== '0' &&
          conditions.push(`{locationData.districtCodeTask} == '''${this.search.districtCode}'''`)

        /// store
        this.search.regionCodeStore &&
          this.search.regionCodeStore !== '0' &&
          conditions.push(`{regionCodeStore} == '''${this.search.regionCodeStore}'''`)
        this.search.provinceCodeStore &&
          this.search.provinceCodeStore !== '0' &&
          conditions.push(`{provinceCodeStore} == '''${this.search.provinceCodeStore}'''`)
        this.search.districtCodeStore &&
          this.search.districtCodeStore !== '0' &&
          conditions.push(`{districtCodeStore} == '''${this.search.districtCodeStore}'''`)

        this.dateRange.startDate &&
          this.dateRange.endDate &&
          conditions.push(
            `{created_date} range [#${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )
        this.dateRangeProcessing.startDate &&
          this.dateRangeProcessing.endDate &&
          conditions.push(
            `{endProcessingTime} range [#${moment(this.dateRangeProcessing.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRangeProcessing.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )

        this.dateRangeEndIntendTime.startDate &&
          this.dateRangeEndIntendTime.endDate &&
          conditions.push(
            `{endIntendTime} range [#${moment(this.dateRangeEndIntendTime.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRangeEndIntendTime.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )

        this.search.moId &&
          this.search.moId !== '' &&
          conditions.push(`{merchantOwnerId} == '''${this.search.moId}'''`)
        this.search.maId &&
          this.search.maId !== '' &&
          conditions.push(`{customerId} == '''${this.search.maId}'''`)
        this.search.storeId &&
          this.search.storeId !== '' &&
          conditions.push(`{storeId} == '''${this.search.storeId}'''`)

        this.search.saleId &&
          this.search.saleId !== '0' &&
          conditions.push(`{assignee.userId} == '''${this.search.saleId}'''`)
        this.search.group &&
          this.search.group !== '0' &&
          conditions.push(`{group} == '''${this.search.group}'''`)
        this.search.name &&
          this.search.name !== '0' &&
          conditions.push(`{purposes} INCLUDE '''${this.search.name}'''`)
        // conditions.push(
        //   `{name} == '''${this.joinArrayData(this.search.name, this.optionsPurpose)}'''`
        // )
        this.search.status &&
          this.search.status !== '0' &&
          conditions.push(`{status} == '''${this.search.status}'''`)

        this.search.typePosm &&
          this.search.typePosm !== '0' &&
          conditions.push(`{typePosm} == '''${this.search.typePosm}'''`)

        this.search.applyFor &&
          this.search.applyFor !== '0' &&
          conditions.push(`{applyFor} == '''${this.search.applyFor}'''`)
        this.search.methodCare &&
          this.search.methodCare !== '0' &&
          conditions.push(`{methodCare} == '''${this.search.methodCare}'''`)

        this.search.reasonFailure &&
          this.search.reasonFailure !== '0' &&
          conditions.push(`{reasonFailure} == '''${this.search.reasonFailure}'''`)

        this.search.typeSale &&
          this.search.typeSale !== '0' &&
          conditions.push(`{handler.typeSale} == '''${this.search.typeSale}'''`)

        this.search.statusChangeInfo &&
          this.search.statusChangeInfo !== '0' &&
          (conditionsMap.statusChangeInfo = this.search.statusChangeInfo)

        this.search.statusApproveMpos &&
          this.search.statusApproveMpos !== '0' &&
          (conditionsMap.statusApproveMpos = this.search.statusApproveMpos)

        this.search.transformStatus &&
          this.search.transformStatus !== '0' &&
          (conditionsMap.transformStatus = this.search.transformStatus)

        this.search.priorities &&
          this.search.priorities.length > 0 &&
          (conditionsMap.priorities = this.search.priorities.map(priority => Number(priority)))

        this.pagination.queryString = conditions.join(' AND ')
        if (conditionsMap) {
          this.pagination.conditionsMap = conditionsMap
        }
      },

      // Dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          this.buildQuery()
          const params = {
            limit: this.search.limit,
            page: this.search.page,
            queryString: this.pagination.queryString,
            ...this.pagination.conditionsMap,
          }

          const res = await List(params)
          if (res.result) {
            // this.dataTask = res.data.taskList ?? []
            this.dataTask = (res.data.taskList ?? []).map(el => {
              return {
                ...el,
                // Chỉ giữ trạng thái checked nếu item có thể chọn và đã được chọn trước đó
                checked: this.canSelectItem(el) && this.idsSelected.includes(el.id),
                isShowMobile: false,
              }
            })
            // Reset selectAll dựa trên items có thể chọn hiện tại
            this.selectAll =
              this.selectableItems.length > 0 && this.selectableItems.every(item => item.checked)

            this.pagination.total = res.data.total ?? 0
            this.totals[0].count = res.data.canceledRecord
            this.totals[1].count = res.data.finishRecord
            this.totals[2].count = res.data.newRecord
            this.totals[3].count = res.data.notCompletedRecord
            this.totals[4].count = res.data.processingRecord
          } else {
            showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.loading = false
        }
      },

      openInGoogleMaps(address) {
        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
        window.open(url, '_blank')
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
      async getOptionType() {
        try {
          const response = await WorkGroupList({
            status: 'APPLYING',
            applyFor: 'CV_CS',
            page: 1,
            size: 1000,
          })
          if (response.code && response.code == 1000) {
            this.optionsType = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.groupCode && current.groupName && current.id) {
                    arr.push({
                      id: current.groupCode,
                      text: current.groupName,
                      mapId: current.id,
                    })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async getCatCalendar() {
        try {
          this.optionsPurpose = []
          this.search.name = ''
          this.search.subCategoryCode = '' // Reset sub category
          this.subCategoryOptions = [] // Clear sub category options
          this.search.callioResult = '' // Reset callio result when group changes
          const wkGroupId = this.optionsType.find(item => item.id == this.search.group)
          if (!wkGroupId) {
            // Clear callio result options when no group is selected
            this.$store.commit('callio/SET_CALLIO_RESULT_OPTIONS', [])
            return
          }

          const response = await WorkTaskList({
            status: 'APPLYING',
            page: 1,
            size: 1000,
            wkGroupId: wkGroupId ? wkGroupId.mapId : '',
          })
          if (response.code && response.code == 1000) {
            this.optionsPurpose = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.taskCode && current.taskName) {
                    arr.push({ id: current.taskCode, text: current.taskName })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }

          // Clear callio result options since task name is reset
          this.$store.commit('callio/SET_CALLIO_RESULT_OPTIONS', [])
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async getCallioResultOptions() {
        try {
          if (
            !this.search.group ||
            this.search.group === '0' ||
            !this.search.name ||
            this.search.name === '0'
          ) {
            this.$store.commit('callio/SET_CALLIO_RESULT_OPTIONS', [])
            return
          }

          const taskCode = this.search.name // Use task code directly

          const params = {
            taskId: 'taskId', // Fixed value as requested
            task: taskCode, // Use task code instead of name
            taskGroup: this.search.group, // Use group code instead of name
          }

          await this.$store.dispatch('callio/getCallResultStatus', params)
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async onTaskNameChange() {
        // Reset callio result when task name changes
        this.search.callioResult = ''
        this.search.subCategoryCode = '' // Reset sub category
        await this.getCallioResultOptions()
        await this.getSubCategoryByTaskCode()
      },
      async getSubCategoryByTaskCode() {
        try {
          if (!this.search.name || this.search.name === '0') {
            this.subCategoryOptions = []
            return
          }

          const response = await CalendarAfsService.getSubCategoryTask({
            taskCode: this.search.name,
          })

          if (response.code === 1000 && response.data) {
            this.subCategoryOptions = response.data.map(item => ({
              id: item.code,
              text: item.name,
            }))
            if (this.subCategoryOptions.length > 0) {
              this.subCategoryOptions.unshift({ id: '0', text: 'Tất cả' })
            }
          } else {
            this.subCategoryOptions = []
            if (response.message) {
              showMessError(this, response.message)
            }
          }
        } catch (e) {
          this.subCategoryOptions = []
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      addTask() {
        // window.open('/customer-support/task/new','_blank')
        this.$router.push('/customer-support/task/new')
      },
      showEditTask(item) {
        this.$refs.popupUpdateTaskRef.show(item.taskWkcldASId)
      },
      onChangeMo() {
        this.search.maId = ''
        this.search.storeId = ''
      },

      onChangeMa() {
        this.search.storeId = ''
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.search.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.code,
              text: e.name,
              idForProvice: e.id,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e, type = 0) {
        if (type === 0) {
          try {
            this.search.provinceCode = ''
            this.search.districtCode = ''
            this.dataDistrict = []
            this.dataProvinceMC = []
            const data = await StaffService.getProvinceRegion({
              regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
            })
            if (data.data.length > 0) {
              this.dataProvinceMC = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMC.unshift({ id: 0, text: 'Tất cả' })
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } else if (type === 1) {
          try {
            this.search.provinceCodeStore = ''
            this.search.districtCodeStore = ''
            this.dataDistrictStore = []
            this.dataProvinceMCStore = []
            const data = await StaffService.getProvinceRegion({
              regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
            })
            if (data.data.length > 0) {
              this.dataProvinceMCStore = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMCStore.unshift({ id: 0, text: 'Tất cả' })
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } else {
          try {
            this.search.handlerMainProvinceId = ''
            this.dataProvinceMC2 = []
            const data = await StaffService.getProvinceRegion({
              regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
            })
            if (data.data.length > 0) {
              this.dataProvinceMC2 = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMC2.unshift({ id: 0, text: 'Tất cả' })
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        }
      },

      async getMcDistrict(event) {
        this.search.districtCode = ''
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrict = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },
      async getMcDistrictStore(event) {
        this.search.districtCodeStore = ''
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrictStore = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        this.dataDistrictStore.unshift({ id: '0', text: 'Tất cả' })
      },

      async getCityList() {
        const mapLocations = await LocationService.getCityList()
        if (mapLocations.success && mapLocations.data) {
          this.cityList = mapLocations.data.map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
        }
      },
      async downloadTemplateFile() {
        try {
          this.isDownloadFile = true
          const res = await DownloadFileTemplate()
          // const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          // const href = window.URL.createObjectURL(blob);
          // const link = document.createElement('a');
          // link.href = href;
          // // link.download = 'template-cskh-task.xlsx';
          // link.setAttribute('download', 'template-cskh-task.xlsx')
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // URL.revokeObjectURL(href);

          FileDownload(res, 'template-cskh-task.xlsx')
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isDownloadFile = false
        }
      },
      async handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          try {
            this.isUploadFile = true
            const formData = new FormData()
            formData.append('file', file)
            const res = await UploadFileListTask(formData, ({ loaded, total }) => {
              console.log(((loaded / total) * 100).toFixed(2).replace('.00', ''))
            })

            if (res.code === 1000) {
              this.$refs.popupShowInfoImportRef.show(res.data)
            } else {
              showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.data?.message || e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } finally {
            this.isUploadFile = false
            this.$refs.fileInput.value = null
          }
        }
      },
      async exportExcel() {
        this.isLoadingDownTemplate = true
        try {
          this.buildQuery()
          const params = {
            limit: this.search.limit,
            page: this.search.page,
            queryString: this.pagination.queryString,
            ...this.pagination.conditionsMap,
          }

          const data = await CommonService.receiveFile({
            object: {
              ...params,
              exportType: 'EXPORT_FOR_ALL',
            },
            type: 'CNPS_CSS_TASK_MKT',
          })
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            'Lỗi khi tải file: ' + error,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoadingDownTemplate = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      onClosePopupImport() {
        this.fetchData()
      },
      copyToClipboard(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            showMess(
              this,
              'Success',
              'Sao chép thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
          .catch(err => {
            console.error('Lỗi khi sao chép: ', err)
            showMess(
              this,
              'Error',
              'Lỗi khi sao chép: ' + err,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
      },
      isPhoneLike(value) {
        if (!value) return false
        const v = String(value).trim()
        if (v.includes('@')) return false
        const normalized = this.normalizePhone(v)
        return /^\d{9,11}$/.test(normalized)
      },
      normalizePhone(value) {
        return String(value)
          .replace(/\s+/g, '')
          .replace(/[-_.]/g, '')
          .replace(/^\+84/, '0')
          .replace(/[^0-9]/g, '')
      },
      maskedPhoneDisplay(value) {
        const n = this.normalizePhone(value)
        if (!/^\d{7,}$/.test(n)) return '***'
        return n.replace(/^(\d{3})\d*(\d{3})$/, '$1***$2')
      },
      handleConfirmCancel(item) {
        this.$refs.popupConfirmCancelRef.show(item)
      },

      // gán sale
      async downloadTemplateFileSale() {
        try {
          this.isDownloadFileSale = true
          const res = await DownloadFileTemplateSale()
          FileDownload(res, 'template-cskh-task-assign-sale.xlsx')
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isDownloadFileSale = false
        }
      },
      async handleFileChangeSale(event) {
        const file = event.target.files[0]
        if (file) {
          try {
            this.isUploadFileSale = true
            const formData = new FormData()
            formData.append('file', file)
            const res = await UploadFileListTaskSale(formData, ({ loaded, total }) => {
              console.log(((loaded / total) * 100).toFixed(2).replace('.00', ''))
            })

            if (res.code === 1000) {
              // this.$refs.popupShowInfoImportRef.show(res.data)
              showMess(
                this,
                'Thông báo',
                res.message,
                'success',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            } else {
              showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.data?.message || e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } finally {
            this.isUploadFileSale = false
            this.$refs.fileInputSale.value = null
          }
        }
      },

      // upload ưu tiên
      async downloadTemplateFilePriority() {
        try {
          this.isDownloadFilePriority = true
          const res = await DownloadFileTemplatePriority()
          FileDownload(res, 'template-cskh-task-update-priority.xlsx')
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isDownloadFilePriority = false
        }
      },
      async handleFileChangePriority(event) {
        const file = event.target.files[0]
        if (file) {
          try {
            this.isUploadFilePriority = true
            const formData = new FormData()
            formData.append('file', file)
            const res = await UploadFileListTaskPriority(formData, ({ loaded, total }) => {
              console.log(((loaded / total) * 100).toFixed(2).replace('.00', ''))
            })

            if (res.code === 1000) {
              // this.$refs.popupShowInfoImportRef.show(res.data)
              showMess(
                this,
                'Thông báo',
                res.message,
                'success',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            } else {
              showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.data?.message || e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } finally {
            this.isUploadFilePriority = false
            this.$refs.fileInputPriority.value = null
          }
        }
      },
      handleSupportMc(item) {
        this.$refs.popupInputSupportMcRef.show(item.id)
      },
    },
  }
</script>
<style scoped lang="scss">
  .wrapper-cancel {
    margin-top: 30px;
    font-size: 24px;
    text-align: center;
    padding: 0 15px;
  }

  .NEW {
    color: #fff;
    background-color: #6c757d !important;
  }

  .time_class {
    width: 250px;
    min-width: 250px;
    /* max-width: 200px; */
  }

  .creator_class {
    min-width: 150px;
    max-width: 220px;
  }

  .task_class {
    min-width: 200px;
    max-width: 200px;
  }

  .type-warning {
    color: #fff;
    background-color: #ffc107;
  }

  .type-success {
    color: #fff;
    background-color: #1a9e3f;
  }

  .type-danger {
    color: #fff;
    background-color: #dc3545;
  }

  .type-primary {
    color: #fff;
    background-color: #007bff;
  }

  .clean-select {
    &:hover {
      text-decoration: line-through;
    }
  }

  /* Làm mờ checkbox bị disabled */
  .form-check-input:disabled {
    opacity: 0.3;
  }
</style>
